<template>
  <div class="contract-list">
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('common:contract_plural') }}
        </h2>

        <DataTablePaginated
            ref="table"
            class="ma-1"
            :headers="headers"
            icon="edit"
            icon2="delete"
            @clickedButton1="openDocumentForm"
            @clickedButton2="deleteWindowOpen"
            @updateTableData="updateTable"
            :addBtn="true"
            @clickedAddButton="openDocumentForm"
            :addBtnText="$t('buttons:add-specific', { specific: $t('common:contract')})"
            sortBy="createdAt"
            :filterName="isAdmin ? `contract` : null"
            sort-desc
        />
      </v-col>
    </v-row>
    <FacilityContractDialogForm
        ref="contractForm"
        :is-global="true"
        @dialogClosed="callUpdateTable"
    />
    <TwoButtonDialog
        ref="deleteButton"
        :dialog-title="$t('dialog:delete-btn-title', {name : $t('common:contract')})"
        :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('common:contract')})"
        :button1-text="$t('buttons:cancel')"
        :button2-text="$t('buttons:delete')"
        :hideButton="true"
        @clickedButton1="$refs.deleteButton.showDialog = false"
        @clickedButton2="deleteContract"
    />
  </div>
</template>

<script>
import GlobalDocumentationService from '@/modules/book/services/global-documentation-service';
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated.vue';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import ContractInfoService from '@/modules/book/services/contract-info-service';
import FacilityContractDialogForm from '@/modules/book/views/facility/facility/formDialogs/FacilityContractDialogForm';
import Utils from '@/modules/core/services/utils';

export default {
  name: "ContractList",
  components: {
    DataTablePaginated,
    FacilityContractDialogForm,
    TwoButtonDialog
  },
  data() {
    return {
      showAll: false,
      currentContract: {},
      isDataLoaded: false,
      tableConfigs: {
        options: {},
        search: ""
      }
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('common:documentation'), value: 'name' },
        { text: this.$t('common:assigned-to'), sortable: false, cellClass: 'facilitylist-name', value: 'facilitiesName' },
        { text: "", value: "controls", sortable: false, align: 'end'},
        {
          text: this.$t('common:customer'),
          value: 'customer',
          filter: {
            type: 'searchable-select',
            group: 0,
            order: 0,
            url: 'customer/all-customers'
          },
          hide: true
        },
      ]
    },
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    }
  },
  mounted() {
    if (this.$route.query.resourceId) {
      this.$refs.table.search = this.$route.query.resourceId;
    }
  },
  methods: {
    openDocumentForm(item) {
      if (item && item.id) {
        this.editContract(item);
      } else {
        this.$refs.contractForm.openNewContractDialog(this.tableConfigs.options, this.tableConfigs.search)
      }
    },
    updateTable(options, search, filter) {
      if (!search) search = '';

      this.tableConfigs.options = options;
      this.tableConfigs.search = search;
      this.$refs.table.loading = true;

      ContractInfoService.readAllByCustomerPaginatedFromAPI(
          options.page - 1,
          options.itemsPerPage,
          search,
          options.sortBy,
          options.sortDesc,
          filter,
          (response) => {
            if (this.$refs.table !== undefined) {
              this.$refs.table.fillTableData(response.data);
              this.contractList = response.data;
              this.checkUrl(response.data.content);
              this.isDataLoaded = true;
            }
            this.$refs.table.loading = false;
          },
          () => {
            this.$refs.table.loading = false;
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:contract_plural')}));
          }
      )
    },
    updateFilter(value) {
      this.showAll = value;
      this.$refs.table.callTableUpdate()
    },
    editContract(item) {
      GlobalDocumentationService.getFacilityBuildInfo(
          item.documentation,
          (response) => {
            this.$refs.contractForm.editGlobalContract(
                response.data,
                item,
                this.tableConfigs.options,
                this.tableConfigs.search
            );
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:contract')}))
          }
      );
    },
    checkUrl(contractList) {
      if (!this.$route.query.contractId || this.isDataLoaded) {
        return;
      }

      let foundFlag = false;
      contractList.forEach((contract) => {
        if (contract.id === this.$route.query.contractId) {
          this.editContract(contract);
          foundFlag = true;
        }
      });

      if (!foundFlag) {
        ContractInfoService.readContract(
            this.$route.query.contractId,
            (contract) => {
              this.editContract(contract.data);
            },
            () => {
              Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:contract')}));
            }
        )
      }
    },
    callUpdateTable() {
      if (!this.$refs.table) return;
      this.$refs.table.callTableUpdate();
    },
    deleteWindowOpen(contract) {
      this.currentContract = contract;
      this.$refs.deleteButton.showDialog = true;
    },
    deleteContract() {
      GlobalDocumentationService.deleteGlobalContract(
          this.currentContract.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('common:contract')}));
            this.callUpdateTable();
            this.currentContract = {};
            this.$refs.deleteButton.showDialog = false;
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('common:contract')}));
            this.currentContract = {};
            this.$refs.deleteButton.showDialog = false;
          }
      )

    }
  }
}
</script>

<style lang="scss">
.contract-list {
  .facilitylist-name {
    width: 75%;
  }

 .container.table-filter-container .col-md-3.col-12 {
   flex: 0 0 100%;
   max-width: 100%;
 }
}
</style>